import R from "ramda";
import { SET_OAUTH_STATE, SET_OAUTH_TOKEN } from "actions/oauth-actions";

export const initialState = {
  token: null,
  oauthState: null
};

export const oauthReducer = (state = initialState, action) => {
  switch (action.type) {
    case SET_OAUTH_STATE:
      return R.merge(state, { oauthState: action.data });
    case SET_OAUTH_TOKEN:
      return R.merge(state, { oauthState: null, token: action.data });
    default:
      return state;
  }
};



// WEBPACK FOOTER //
// ./src/js/reducers/oauth-reducer.js